/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_166_TitleInputs */

const en_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffee Macaron`)
};

const ar_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون القهوة`)
};

const de_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaffee-Macaron`)
};

const es_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de café`)
};

const fr_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron au café`)
};

const it_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron al caffè`)
};

const ja_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーヒーマカロン`)
};

const ko_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커피 마카롱`)
};

const pt_br_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de Café`)
};

const ru_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кофейный макарон`)
};

const th_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการองกาแฟ`)
};

const tr_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kahveli Makaron`)
};

const zh_cn_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咖啡马卡龙`)
};

const zh_tw_tree_type_166_title = /** @type {(inputs: Tree_Type_166_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咖啡馬卡龍`)
};

/**
* | output |
* | --- |
* | "Coffee Macaron" |
*
* @param {Tree_Type_166_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_166_title = /** @type {((inputs?: Tree_Type_166_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_166_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_166_title(inputs)
	if (locale === "ar") return ar_tree_type_166_title(inputs)
	if (locale === "de") return de_tree_type_166_title(inputs)
	if (locale === "es") return es_tree_type_166_title(inputs)
	if (locale === "fr") return fr_tree_type_166_title(inputs)
	if (locale === "it") return it_tree_type_166_title(inputs)
	if (locale === "ja") return ja_tree_type_166_title(inputs)
	if (locale === "ko") return ko_tree_type_166_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_166_title(inputs)
	if (locale === "ru") return ru_tree_type_166_title(inputs)
	if (locale === "th") return th_tree_type_166_title(inputs)
	if (locale === "tr") return tr_tree_type_166_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_166_title(inputs)
	return zh_tw_tree_type_166_title(inputs)
});